export function inr(n) {
  if (n >= 1e7) return `₹${(n / 1e7).toFixed(2).replace(/\.00$/, "")} Cr`;
  if (n >= 1e5) return `₹${(n / 1e5).toFixed(1).replace(/\.0$/, "")} L`;
  return `₹${Math.round(n).toLocaleString("en-IN")}`;
}

export function inrFull(n) {
  return `₹${Math.round(n).toLocaleString("en-IN")}`;
}

export function sqm(sqYd) {
  return Math.round(sqYd * 0.836127);
}
